export const fromStatic = (staticValue) => () => Promise.resolve(staticValue);
